import './index.scss'
$(".section2 .nav div").eq(0).addClass("active").siblings().removeClass("active");
$(".section2 .ul ul").eq(0).addClass("active").siblings().removeClass("active");
$(".section2 .nav div").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section2 .ul ul").eq(index).addClass("active").siblings().removeClass("active");
})

$(".section7 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".text").slideToggle();
})